import { type TenderRateType } from './TenderRateType'
import { type TenderStatus } from './TenderStatus'

export type Tender = {
  rateType: TenderRateType
  status: TenderStatus
}

export function isTenderAvailable({ status }: Tender) {
  return status === 'available'
}

export function isTenderAccepted(tender?: Tender) {
  if (!tender) return false

  const { status } = tender
  return status === 'accepted'
}

export function isTenderRejected(tender?: Tender) {
  if (!tender) return false

  const { status } = tender
  return status === 'rejected'
}
